import forge from 'node-forge';

export async function rsaEncryptBase64(publicKeyPem: string, plaintext: string): Promise<string> {
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

  const u8 = new TextEncoder().encode(plaintext);

  const buf = forge.util.createBuffer();

  for (let i = 0; i < u8.length; i++) buf.putByte(u8[i]);

  const raw = buf.getBytes();

  const encryptedBinaryStr = publicKey.encrypt(raw, 'RSA-OAEP', {
    md: forge.md.sha1.create(),
    mgf1: forge.mgf.mgf1.create(forge.md.sha1.create()),
  });

  const encryptedB64 = forge.util.encode64(encryptedBinaryStr);
  return encryptedB64;
}
